import { saveAuthToken, deleteAuthData } from '../services';
import jwtDecode from 'jwt-decode';
import { DEFAULT_MVW } from 'config/constants';

const initialState = {
  id: null,
  name: null,
  isAuthenticated: false,
  isAuthenticating: false,
  statusText: null,
  picture_url: null,
  role: null,
  preferences: {},
  lead_cert_number: null,
  manage_vendor_workrooms: { ...DEFAULT_MVW },
};

const setUserState = (state, payload) => {
  const { auth_token: authToken, ...pay } = payload;
  const jwtPayload = jwtDecode(authToken);
  return {
    ...state,
    ...pay,
    isAuthenticated: true,
    isAuthenticating: false,
    statusText: null,
    role: jwtPayload.role,
  };
};

const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'LOGIN_USER_REQUEST': {
      return { ...state, isAuthenticating: true, statusText: null };
    }
    case 'USER_GET_SESSION_REQUEST':
      return {
        ...state,
        isAuthenticated: true,
        isAuthenticating: true,
      };
    case 'LOGIN_USER_SUCCESS': {
      saveAuthToken(payload.auth_token);
      return setUserState(state, payload);
    }
    case 'USER_GET_SESSION_SUCCESS':
      return setUserState(state, payload);
    case 'USER_UPDATE_PREFERENCES_SUCCESS':
      return {
        ...state,
        ...payload,
      };
    case 'LOGIN_USER_FAILURE': {
      deleteAuthData();
      return { ...initialState, statusText: payload.error };
    }
    case 'LOGOUT_USER': {
      deleteAuthData();
      return { ...initialState, statusText: payload.reason };
    }
    default: {
      return state;
    }
  }
};

export default userReducer;

export const isAdmin = state => state.role === 'admin';
export const getRole = state => state.role;
export const getEmployableId = state => state.employable_id;
export const getEmployableType = state => state.employable_type;
export const getInstallerId = state => state.installer_id;
export const getPosition = state => state.position;
export const getManageVendorWorkrooms = state => state.manage_vendor_workrooms;



// WEBPACK FOOTER //
// ./client/app/reducers/user.js